import React, { useEffect, useState } from 'react'
import Imgaaa from '../../../assets/images/PurpleIcon.png';
import { BsThreeDotsVertical } from "react-icons/bs";
import { Popover } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';

const AllCustomerCom = ({name,date,status,payment,item,Imaag,onclick}) => {
    const [anchorEl, setAnchorEl] = useState(null);
const navigator = useNavigate()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
 

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <div className='main-div-all-cutomers-com' onClick={onclick} style={{cursor:'pointer'}}>
        <div className='colm-div-customer-com'>
        <div style={{display:'flex',gap:'12px'}}>
             <img   src={
    Imaag?.includes('/media/image/cover-image.jpeg')
      ? Imgaaa
      : Imaag || Imgaaa
  } style={{width:'3em',height:'3em',objectFit:'cover',borderRadius:5,boxShadow:'rgb(191 184 184) 0px 0px 2px 2px'}}/>
              <div className='top-custorm-width'>
              <h5 className='h5-class-top-class'>{name}</h5>
             
          <p className='paragprh-customer-com'>{formatDate(date) + " At "  + formatTimeInTimezone(date)  }</p>
              </div>
             </div>
        </div>
        <div className='colm-div-customer-com'>
        <h5 className='paragraph-text-p'>Status</h5>
        <h5 className='h5-class-top-class'>{status}</h5>
        </div>
        <div className='colm-div-customer-com'>
        <h5 className='paragraph-text-p'>Total Cost</h5>
        <h5 className='h5-class-top-class'>{payment} <span style={{ fontSize: 9 }}>AED</span></h5>
        <BsThreeDotsVertical  className='threedor-icon forcefully-threedot' />
        
        </div>
    </div>
  )
}

export default AllCustomerCom